export default __webpack_public_path__ + "static/media/regulatory--turn-right-ahead--g1.76f304e8.png";